// extracted by mini-css-extract-plugin
export default {"tldPrefillDescription":"NzodTd"};